module.exports = __webpack_public_path__ + "static/media/google_20.73ed4734.svg";